import React from 'react'
export default function Menu__Icon({ size = 24, width = size, height = size, fill, secondaryFill, stroke, secondaryStroke, children }) {
  return (<svg width={width} height={height} xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 48 48">{children}
<g fill={fill} stroke={stroke} className="nc-icon-wrapper"><path d="M2 22h44v4H2z" fill={secondaryFill} stroke={secondaryStroke}/><path d="M2 8h44v4H2z"/><path d="M2 36h44v4H2z"/></g></svg>)
}
